<!-- Skeleton loader -->
<div *ngIf="loading" class="mb-4">
    <p-skeleton height="3rem" width="50%" styleClass="mb-3"></p-skeleton>
    <p-skeleton height="25rem" width="70%"></p-skeleton>
</div>

<!-- Content when loaded -->
<div *ngIf="!loading">
    <div *ngIf="userCVAndNameInfo?.userCvFileUrl && userCVAndNameInfo?.userCvFileUrl.trim() !== ''" class="grid">
        <!-- Sol: CV -->
        <div class="col-12 xl:col-7">
            <div class="p-4 border-round-lg pdf-background-container mb-3">
                <div class="flex flex-row align-items-center justify-content-between">
                    <div class="flex align-items-center justify-content-center">
                        <img src="../../../../../assets/vinter/icons/copy-file-icon.svg" />
                        <span class="pl-3 font-medium text-sm text-gray-900">{{formattedCvFileName}}</span>
                    </div>
                    <div class="flex align-items-center">
                        <img (click)="downloadOriginalPdf(userCVAndNameInfo?.userCvFileUrl)"
                            src="../../../../../assets/vinter/icons/download-pdf-icon.svg" style="cursor: pointer;" />
                    </div>
                </div>
            </div>

            <div class="pdf-viewer-container p-0 h-screen block border-round-lg overflow-hidden">
                <pdf-viewer *ngIf="userCVAndNameInfo?.userCvFileUrl != null" [src]="userCVAndNameInfo?.userCvFileUrl"
                [render-text]="true"
                [fit-to-page]="true"
                [zoom]="1"
                [original-size]="false"
                [show-borders]="false"
                [autoresize]="true"
                style="height: 100%; width: 100%; display: block;" class="overflow-hidden">
            </pdf-viewer>
            </div>
        </div>

        <!-- Sağ: CV değerlendirme paneli — durum için bkz. cvPanelState (ts) -->
        <div class="col-12 xl:col-5" [ngSwitch]="cvPanelState">

            <!-- 1) Pozisyonda CV adımı yok → değerlendirme yapılmaz -->
            <div *ngSwitchCase="'noCvStep'" class="cv-info-note">
                <i class="pi pi-info-circle"></i>
                <span>{{ 'Key.ResumeCvNoCvStepInfo' | translate }}</span>
            </div>

            <!-- 2a) Analiz tamamlandı → skor + açıklama -->
            <ng-container *ngSwitchCase="'scored'">
                <div class="score-section">
                    <div class="score-label">{{ 'Key.CvScoringSidebarCvScore' | translate }}</div>
                    <div class="score-row">
                        <div class="score-big">{{ userCVAndNameInfo.cvScore }} <span class="score-suffix">/ 100</span></div>
                        <span class="match-pill" [ngClass]="cvMatchClass">
                            <ng-container *ngIf="userCVAndNameInfo?.cvScoreThreshold != null">{{ 'Key.CvScoringThreshold' | translate }} {{ userCVAndNameInfo.cvScoreThreshold }} · </ng-container>
                            {{ cvMatchLabel }}
                        </span>
                    </div>
                    <div class="score-bar">
                        <div class="score-bar-fill" [style.width.%]="userCVAndNameInfo.cvScore" [ngClass]="cvMatchClass"></div>
                    </div>
                </div>
                <div class="reasoning-section" *ngIf="userCVAndNameInfo?.cvScoreReasoning">
                    <h4>{{ 'Key.CvScoringSidebarScoreExplanation' | translate }}</h4>
                    <p class="reasoning-text">{{ userCVAndNameInfo.cvScoreReasoning }}</p>
                </div>
            </ng-container>

            <!-- 2b) Analiz sürüyor -->
            <ng-container *ngSwitchCase="'analyzing'">
                <div class="score-label">{{ 'Key.CvScoringSidebarCvScore' | translate }}</div>
                <div class="cv-analyzing">
                    <i class="pi pi-spin pi-spinner"></i>
                    <span>{{ 'Key.CvAnalyzing' | translate }}</span>
                </div>
            </ng-container>

            <!-- 2c) Analiz başarısız → not + tekrar dene -->
            <ng-container *ngSwitchCase="'failed'">
                <div class="cv-info-note cv-info-note--error">
                    <i class="pi pi-exclamation-triangle"></i>
                    <span>{{ 'Key.ResumeCvAnalysisFailed' | translate }}</span>
                </div>
                <button type="button" class="cv-action-btn cv-action-btn--outlined" (click)="triggerCvAnalysis()" [disabled]="triggeringAnalysis">
                    <i class="pi" [ngClass]="triggeringAnalysis ? 'pi-spin pi-spinner' : 'pi-refresh'"></i>
                    <span>{{ 'Key.ResumeCvRetryAnalysis' | translate }}</span>
                </button>
            </ng-container>

            <!-- 3) CV adımı var ama aday davetle geldi (bu pozisyon için analiz yok) → mevcut CV'yi analiz et -->
            <ng-container *ngSwitchCase="'notAnalyzed'">
                <div class="cv-info-note">
                    <i class="pi pi-info-circle"></i>
                    <span>{{ 'Key.ResumeCvNotUploadedForPosition' | translate }}</span>
                </div>
                <button type="button" class="cv-action-btn" (click)="triggerCvAnalysis()" [disabled]="triggeringAnalysis">
                    <i class="pi" [ngClass]="triggeringAnalysis ? 'pi-spin pi-spinner' : 'pi-chart-bar'"></i>
                    <span>{{ 'Key.ResumeCvAnalyzeExistingCv' | translate }}</span>
                </button>
            </ng-container>
        </div>
    </div>
    <div *ngIf="!userCVAndNameInfo?.userCvFileUrl || userCVAndNameInfo?.userCvFileUrl.trim() === ''"
        class="no-position justify-content-center flex flex-column align-items-center">
        <img class="no-position-gift" [width]="219" height="219"
            src="assets/vinter/gifs/cannot-found-past-position.gif">
        <span class="justify-content-start font-semibold text-center flex text-gray-800">{{"Key.NoUserCV" |
            translate}}</span>
    </div>
</div>